import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Eesti",
  code: "et",
  messages: {
    alert: {
      close: "Sulge"
    },
    authForm: {
      hidePassword: "Peida parool",
      showPassword: "N\xE4ita parooli",
      submit: "J\xE4tka"
    },
    banner: {
      close: "Sulge"
    },
    calendar: {
      nextMonth: "J\xE4rgmine kuu",
      nextYear: "J\xE4rgmine aasta",
      prevMonth: "Eelmine kuu",
      prevYear: "Eelmine aasta"
    },
    carousel: {
      dots: "Valige kuvatav slaid",
      goto: "Mine slaidile {slide}",
      next: "J\xE4rg",
      prev: "Eel"
    },
    chatPrompt: {
      placeholder: "Siia kirjutage oma s\xF5num..."
    },
    chatPromptSubmit: {
      label: "Saada"
    },
    colorMode: {
      dark: "Tume",
      light: "Hele",
      switchToDark: "L\xFClitu tumedasse re\u017Eiimi",
      switchToLight: "L\xFClitu heledasse re\u017Eiimi",
      system: "S\xFCsteem"
    },
    commandPalette: {
      back: "Tagasi",
      close: "Sulge",
      noData: "Pole andmeid",
      noMatch: "Pole vastavaid andmeid",
      placeholder: "Sisesta k\xE4sk v\xF5i otsi..."
    },
    contentSearch: {
      links: "Lingid",
      theme: "Teema"
    },
    contentSearchButton: {
      label: "Otsi..."
    },
    contentToc: {
      title: "Sellel lehel"
    },
    dashboardSearch: {
      theme: "Teema"
    },
    dashboardSearchButton: {
      label: "Otsi..."
    },
    dashboardSidebarCollapse: {
      collapse: "Ahenda k\xFClgriba",
      expand: "Laienda k\xFClgriba"
    },
    dashboardSidebarToggle: {
      close: "Sulge k\xFClgriba",
      open: "Ava k\xFClgriba"
    },
    error: {
      clear: "Tagasi avalehele"
    },
    fileUpload: {
      removeFile: "Eemalda {filename}"
    },
    header: {
      close: "Sulge men\xFC\xFC",
      open: "Ava men\xFC\xFC"
    },
    inputMenu: {
      create: 'Loo "{label}"',
      noData: "Pole andmeid",
      noMatch: "Pole vastavaid andmeid"
    },
    inputNumber: {
      decrement: "V\xE4henda",
      increment: "Suurenda"
    },
    modal: {
      close: "Sulge"
    },
    pricingTable: {
      caption: "Hinna plaanide v\xF5rdlus"
    },
    prose: {
      codeCollapse: {
        closeText: "Ahenda",
        name: "kood",
        openText: "Laienda"
      },
      collapsible: {
        closeText: "Peida",
        name: "omadused",
        openText: "N\xE4ita"
      },
      pre: {
        copy: "Kopeeri kood l\xF5ikelauale"
      }
    },
    selectMenu: {
      create: 'Loo "{label}"',
      noData: "Pole andmeid",
      noMatch: "Pole vastavaid andmeid",
      search: "Otsi..."
    },
    slideover: {
      close: "Sulge"
    },
    table: {
      noData: "Pole andmeid"
    },
    toast: {
      close: "Sulge"
    }
  }
});
